var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentType,{tag:"component",staticClass:"c-list-group-item tw-flex-1 tw-text-lg tw-block",class:[
    {
      '!tw-text-white tw-bg-primary-400  active-list-item': _vm.active,
      '!tw-text-grey-500 !tw-cursor-default ': _vm.disabled,
      'tw-cursor-pointer': _vm.href || _vm.to || _vm.$listeners.click,
      '!tw-border-0 !tw-py-0': _vm.borderBottomOnly,
      'tw-w-full tw-text-left ': _vm.button,
      'tw-text-grey-900 hover:tw-bg-grey-200 hover:!tw-text-grey-900':
        !_vm.disabled && !_vm.isMobile && !_vm.button,
      'focus:tw-bg-grey-200 active:!tw-bg-grey-200 active:!tw-text-grey-700':
        !_vm.disabled && _vm.button,
      '!tw-bg-grey-200 !tw-text-grey-700': _vm.disabled && _vm.button,
      'tw-px-5 tw-py-3': !_vm.noPadding,
      'tw-bg-white': !_vm.button
    },
    _vm.variantClass
  ],attrs:{"href":_vm.href,"to":_vm.to,"disabled":_vm.disabled,"squared":_vm.button},on:{"click":_vm.handleClick}},[_c(_vm.button ? 'span' : 'div',{tag:"component",class:[
      {
        'tw-border-b tw-py-3 tw-border-b-solid tw-border-grey-300': _vm.borderBottomOnly
      },
      _vm.itemWrapperClass
    ]},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }